import OracleCardDetail from '../../components/oracle/OracleCardDetail';

function OracleCardDetailPage({ lang = 'es' }) {
  return (
    <main className="bg-gray-900 min-h-screen py-10">
      <OracleCardDetail lang={lang} />
    </main>
  );
}

export default OracleCardDetailPage;